var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrap},[_c('div',[_c('img',{class:_vm.$style.icon,attrs:{"src":require("@/assets/imgs/路径@2x.png"),"alt":""},on:{"click":_vm.goBack}}),_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }